// StagePill.tsx - the small segmented stage pill (Observe | Diagnose | Solo), quiet until tapped
// (locked DX4: not full-width toggle chrome). Controlled: the parent owns the active stage.
export type Stage = 'observe' | 'diagnose' | 'solo';

const STAGES: { id: Stage; label: string }[] = [
  { id: 'observe', label: 'Observe' },
  { id: 'diagnose', label: 'Diagnose' },
  { id: 'solo', label: 'Solo' },
];

export interface StagePillProps {
  stage: Stage;
  onChange: (stage: Stage) => void;
}

export function StagePill({ stage, onChange }: StagePillProps) {
  return (
    <div className="segwrap">
      <div className="seg">
        {STAGES.map(({ id, label }) => (
          <button
            key={id}
            type="button"
            className={'s' + (stage === id ? ' on' : '')}
            aria-pressed={stage === id}
            onClick={() => onChange(id)}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
